import { Flex, Text } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useDontShowAgain } from '~/atoms/DontShowAgain'
import { useModalState } from '~/atoms/ModalState'
import { Checkbox } from '~/components/shared/Checkbox'
import { MangoButtonVariant } from '~/components/shared/componentStyles/MangoButton.style'
import { MangoButton } from '~/components/shared/MangoButton'
import { MangoModal } from '~/components/shared/MangoModal'
import { useConfirmModalStyle } from '~/pages/Home/Modals/ConfirmModal/componentStyles/ConfirmModal.style'
import { Size } from '~/types/ThemeTypes'

const ConfirmModal = () => {
  const {
    confirmModal: [confirmModalState, setConfirmModalState],
  } = useModalState()

  const [, setDontShowAgain] = useDontShowAgain()
  const [isDontShowAgainChecked, setIsDontShowAgainChecked] = useState(false)

  const styles = useConfirmModalStyle()

  const title = confirmModalState?.title ?? 'Are you sure?'
  const message =
    confirmModalState?.message ??
    'Deleting this voicemail is permanent and cannot be undone.'

  const handleConfirm = () => {
    if (!confirmModalState) return
    const { onConfirm, closeAfterConfirm = true } = confirmModalState

    if (isDontShowAgainChecked) {
      setDontShowAgain(confirmModalState?.dontShowAgainKey)
    }
    if (onConfirm) onConfirm()

    if (closeAfterConfirm) setConfirmModalState(null)
  }

  const handleCloseModal = () => {
    if (!confirmModalState) return
    const { onCancel } = confirmModalState
    if (onCancel) onCancel()
    setConfirmModalState(null)
  }

  useEffect(() => {
    setIsDontShowAgainChecked(false)
  }, [confirmModalState])

  return (
    <MangoModal
      isOpen={confirmModalState !== null}
      header={title}
      onClose={handleCloseModal}
      size={Size.sm}
      body={
        <Flex sx={styles.bodyContainer}>
          {typeof message === 'string' ? (
            <Text sx={styles.bodyText}>{message}</Text>
          ) : (
            message
          )}
          {confirmModalState?.dontShowAgainKey && (
            <Checkbox
              label="Don't ask again"
              onChange={setIsDontShowAgainChecked}
            />
          )}
        </Flex>
      }
      footer={
        <Flex sx={styles.footerContainer}>
          {confirmModalState?.cancelText && (
            <MangoButton
              variant={MangoButtonVariant.Default_100}
              onClick={handleCloseModal}
            >
              {confirmModalState?.cancelText}
            </MangoButton>
          )}
          <MangoButton
            variant={
              confirmModalState?.isDestructive
                ? MangoButtonVariant.Destructive_300
                : MangoButtonVariant.Default_300
            }
            onClick={handleConfirm}
          >
            {confirmModalState?.confirmText}
          </MangoButton>
        </Flex>
      }
    ></MangoModal>
  )
}

export default ConfirmModal
